import React from 'react';
// eslint-disable-next-line
import i18n from "../../i18n";
import { useTranslation } from 'react-i18next';
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css';
import './Hero.css';
import Cardicon from '../Cardicon/Cardicon';

const Hero = () => {
    // eslint-disable-next-line
    const { t, i18n } = useTranslation();
    return (
        <>
        <section id='Hero' className="d-flex Hero align-items-center">
            <div className="container  position-relative">
                <div className='row justify-content-center'>
                    <div className='col-xl-7 col-lg-9 text-center'>
                         <h1>Java Source Company</h1>
                         <h2 >{t('Servicesoftwarecompany')}</h2>
                    </div>
                </div>
                <Cardicon />
            </div>
      </section>
      
      </>
    )
}

export default Hero
